import React from 'react'
import _ from 'lodash'

import AccommodationInput from './AccommodationInput'
import CounterButton from '../CounterButton/CounterButton'
import Room from './Room'

import '../../styles/scss/elements/accommodation-form.scss'

const AccommodationForm = ({
  accommodationOptions,
  addRoom,
  preAcc,
  postAcc,
  removeRoom,
  rooms,
  setPreAcc,
  setPostAcc,
  updateRoom,
}) => {
  return (
    <div className="u-full-width accommodation-form">
      <div className="u-flex u-flex-column accommodation-form__passenger-details">
        <div className="u-flex u-flex-align-center u-flex-space-between accommodation-form__passenger-details__wrapper">
          <div className="accommodation-form__passenger-details__heading__left">
            <p className="price-heading">
              <span className="info-indicator">*</span> How Many Rooms?
            </p>
          </div>
          <CounterButton
            value={_.size(rooms)}
            addCounter={addRoom}
            subCounter={removeRoom}
          />
        </div>
        {_.map(rooms, (room, index) => (
          <Room
            key={`${index}`}
            roomNumber={index + 1}
            room={room}
            updateRoom={updateRoom}
          />
        ))}
      </div>
      {!_.isEmpty(accommodationOptions) && (
        <div className="u-flex u-flex-column accommodation-form__accommodation-details">
          {_.get(accommodationOptions, 'preAcc') && (
            <AccommodationInput
              headerLabel="Will you be staying at accomodations at the beginning of your trip?"
              inputLabel="Number of nights staying at accomodations beforehand"
              onChangeText={setPreAcc}
              value={preAcc}
            />
          )}
          {_.get(accommodationOptions, 'postAcc') && (
            <AccommodationInput
              headerLabel="Will you be staying at accomodations at the end of your trip?"
              inputLabel="Number of nights staying at accomodations after the trip"
              onChangeText={setPostAcc}
              value={postAcc}
            />
          )}
        </div>
      )}
    </div>
  )
}

export default AccommodationForm
